export const formGroup = {
  kodeCabang: { value: "", mandatory: true },
  ahmDealerCode: { value: "" },
  namaDealer: { value: "", mandatory: true },
  namaPT: { value: "" },
  alamat: { value: "" },
  longitude: { value: "" },
  latitude: { value: "" },
  idProvince: { value: null },
  idKecamatan: { value: null },
  idKota: { value: null },
  kodePos: { value: null },
  idKelurahan: { value: "" },
  email: { value: "" },
  kodeMD: { value: "" },
  npwp: { value: "" },
  idWilayah: { value: null, mandatory: true },
  phoneBengkel: { value: "" },
  phoneShowroom: { value: "" },
  phoneCRM: { value: "" },
  facebookName: { value: "" },
  instagramName: { value: "" },
  fotoGedungUrl: { value: "" },
  fotoStampelUrl: { value: "", mandatory: true },
  fotoMateraiUrl: { value: "", mandatory: true },
  fotoTemplateKwitansiUrl: { value: "", mandatory: true },
  status: { value: "INACTIVE" },
  listAhmDealer: { value: null },
};

export const tableColumns = [
  {
    name: "namaDealer",
    label: "Nama Dealer",
  },
  {
    name: "kodeCabang",
    label: "Kode Cabang",
  },
  {
    name: "wilayahName",
    label: "Wilayah",
  },
  {
    name: "email",
    label: "Email",
  },
  {
    name: "phoneBengkel",
    label: "No. Telp. Bengkel",
  },
];
